import { useSelector } from 'react-redux'

const removeDuplicates = arr => [...new Set(arr)]

export default () => {
  const currentCourses = useSelector(state => state.usercourses.currentUserCourses)

  const masterCourseIds = removeDuplicates(
    currentCourses.map(c => c.master_course.id)
  )

  return masterCourseIds
}
